<div class="lending-library__wrapper">
    <div class="lending-library_elements">
        <ng-container *ngFor="let i of content | keyvalue; let idx = index">
            <div *ngIf="i?.value?.type!=='interactive_wrapper'" class="libElement lending-library__element" [ngClass]="activeComponent === idx ? 'active' : ''" (click)="setInnerContent(i?.value?.title, i?.value?.text, i?.value?.textDesktop, idx)">
                <img [src]="i?.value?.icon.data.attributes.url" [alt]="i?.value?.icon.alternativeText" alt="" loading="lazy">
                <span>{{i.value.iconHeader}}</span>
            </div>
        </ng-container>
    </div>
    <div class="libContentDiv lending-library__content">
      <div class="libraryTitleDiv lending-library__content_title">{{innerTitle}}</div>
      <div *ngIf="breakpoints.extraSmall" class="libraryContentDiv lending-library__content_description outer" [innerHTML]="innerText"></div>
      <div *ngIf="!breakpoints.extraSmall" class="libraryContentDiv lending-library__content_description outer" [innerHTML]="innerTextDesktop"></div>
    </div>
</div>
